<template>
  <div class="loader__wrapper">
    <div class="loader"></div>
  </div>
</template>

<script>
  export default {
    name: 'Loader',
  };
</script>
